window.addEventListener("load", () => {
  const positions = document.querySelectorAll(".position");

  for (let position of positions) {
    console.log(position);
    let currBtn = position.querySelector(".position-toggle");
    let content = position.querySelector(".position-content");
    let title = position.querySelector(".position-title");

    title.addEventListener("click", () => {
      currBtn.classList.toggle("open");
      content.classList.toggle("open");
    });
  }
});
